import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inputNumberFractionDigitByCurrency',
})
export class InputNumberFractionDigitByCurrencyPipe implements PipeTransform {
  transform(config: string): number {
    if (config.includes('.') && config.includes('-')) {
      const range = config.split('.')[1].split('-');
      return parseInt(range[0], 10);
    }
    return 0;
  }
}
